(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/transcript-card.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/transcript-card.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  CardBody,
  CardExpandableBody
} = svs.ui.ReactCard;
const {
  ReactInfoButtonText
} = svs.tb_ui;
const {
  WhiteCardHeader,
  PdCard
} = svs.myProfile.react.pages.myInformation.myInformation.components;
const {
  TranscriptOrderedDownload,
  TranscriptOrderedThankYou,
  TranscriptReadDocument,
  TopBottomBorder
} = svs.myProfile.react.pages.myInformation.transcript.transcript;
const {
  showAboutTranscript
} = svs.myProfile.react.shared.dialogs;
const isPnp = svs.core.config.data.svsconfig.site === 'momang';

const TranscriptCard = _ref => {
  let {
    transcript,
    handleOrderClick
  } = _ref;
  return React.createElement(PdCard, null, React.createElement(WhiteCardHeader, null, "Personuppgifter"), React.createElement(CardBody, {
    className: "f-left pd-card-body"
  }, (transcript === null || transcript === void 0 ? void 0 : transcript.OrderStatus) === 'READY' && React.createElement("p", null, "Ditt utdrag \xE4r redo att h\xE4mtas.")), React.createElement(CardExpandableBody, {
    className: "f-left pd-card-body"
  }, !transcript && React.createElement(React.Fragment, null, React.createElement("p", null, "Du kan best\xE4lla ett utdrag p\xE5 vilka  personuppgifter som vi behandlar n\xE4r du \xE4r kund hos oss."), React.createElement(Button, {
    block: true,
    className: "margin-v-2",
    inverted: true,
    onClick: () => handleOrderClick('1'),
    size: 300,
    transparent: isPnp
  }, "Best\xE4ll registerutdrag")), (transcript === null || transcript === void 0 ? void 0 : transcript.OrderStatus) === 'READY' && React.createElement(React.Fragment, null, React.createElement(TranscriptReadDocument, null), React.createElement(TopBottomBorder, null, React.createElement(TranscriptOrderedDownload, {
    transcript: transcript,
    transcriptType: "Personuppg."
  })), React.createElement("p", null, "Ditt registerutdrag \xE4r tillg\xE4ngligt h\xE4r p\xE5 Min profil f\xF6r nedladdning i upp till 30 dagar.", ' ', "Har du fr\xE5gor om ditt registerutdrag \xE4r du v\xE4lkommen att skicka ett e-post till dataskyddsombudet@svenskaspel.se.")), (transcript === null || transcript === void 0 ? void 0 : transcript.OrderStatus) === 'NOTREADY' && React.createElement("div", {
    className: "u-border-bottom-1 padding-v-1 margin-bottom-1 ".concat(isPnp ? 'border-white' : 'border-navy')
  }, React.createElement(TranscriptOrderedThankYou, {
    thankYouText: "registerutdrag"
  })), React.createElement(ReactInfoButtonText, {
    onClickFunction: showAboutTranscript,
    text: "L\xE4s mer om registerutdrag"
  })));
};
svs.myProfile.react.pages.myInformation.transcript.transcript.TranscriptCard = TranscriptCard;

 })(window);